module.exports = __webpack_public_path__ + "img/task-centre-active.3b9de2b1.svg";